var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
var __await = (this && this.__await) || function (v) { return this instanceof __await ? (this.v = v, this) : new __await(v); }
var __asyncDelegator = (this && this.__asyncDelegator) || function (o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
};
var __asyncGenerator = (this && this.__asyncGenerator) || function (thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function () { return this; }, i;
    function awaitReturn(f) { return function (v) { return Promise.resolve(v).then(f, reject); }; }
    function verb(n, f) { if (g[n]) { i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; if (f) i[n] = f(i[n]); } }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
};
define(["require", "exports", "./base-chat-service"], function (require, exports, base_chat_service_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.DEFAULT_MULTIMODAL_LLM = exports.OpenAIChatCompletionV1BetaClient = void 0;
    class OpenAIChatCompletionV1BetaClient extends base_chat_service_1.BaseChatV1BetaClient {
        constructor(options) {
            super(options);
            this.path = "/completions";
        }
        create(request, requestOptions) {
            throw new Error('Method not implemente yet');
        }
        createStream(request, requestOptions) {
            return __asyncGenerator(this, arguments, function* createStream_1() {
                var _a, _b;
                this.appendRequestOptions(request, { "organization_id": (_a = this.channelOptions) === null || _a === void 0 ? void 0 : _a.organizationId, "team_id": (_b = this.channelOptions) === null || _b === void 0 ? void 0 : _b.teamId });
                yield __await(yield* __asyncDelegator(__asyncValues(this.performStreamRequest(request, requestOptions))));
            });
        }
        appendRequestOptions(request, options = {}) {
            const validOptions = this.removeEmptyParams(options);
            if (Object.keys(validOptions).length > 0) {
                request["mindbreeze_user_context"] = Object.assign(Object.assign({}, request["mindbreeze_user_context"]), validOptions);
            }
        }
    }
    exports.OpenAIChatCompletionV1BetaClient = OpenAIChatCompletionV1BetaClient;
    exports.DEFAULT_MULTIMODAL_LLM = 'default-multimodal-llm';
});
